import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Redirect to /verify-email when 428 (email not verified)
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 428 && !window.location.pathname.startsWith("/verify-email")) {
      window.location.href = "/verify-email";
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (path) => (path ? `${API}/files/${path}` : "");

export const KECAMATAN_MAGELANG = [
  "Magelang Utara", "Magelang Tengah", "Magelang Selatan",
  "Bandongan", "Borobudur", "Candimulyo", "Dukun", "Grabag", "Kajoran", "Kaliangkrik",
  "Mertoyudan", "Mungkid", "Muntilan", "Ngablak", "Ngluwar", "Pakis", "Salam",
  "Salaman", "Sawangan", "Secang", "Srumbung", "Tegalrejo", "Tempuran", "Windusari",
];
